<template>
	<b-row>
		<b-col>
			<b-card>
<!--				<div slot="header">-->
<!--					<h5>{{$t('analytics')}}</h5>-->
<!--				</div>-->
				<b-tabs content-class="mt-3" fill>
					<b-tab :title="$t('Income Analytics')" active>
						<income-analytics></income-analytics>

					</b-tab>
					<b-tab :title="$t('Sale Analytics')">
						<sale-analytics ></sale-analytics>

					</b-tab>
					<b-tab :title="$t('Monthly Analytics')">
						<monthly-analytics ></monthly-analytics>

					</b-tab>

				</b-tabs>

			</b-card>
		</b-col>
	</b-row>
</template>

<script>
import SaleAnalytics from './SaleAnalytics'
import IncomeAnalytics from './IncomeAnalytics'
import MonthlyAnalytics from "./MonthlyAnalytics";

export default {
		name: 'Analytics',
		components: {MonthlyAnalytics,SaleAnalytics,IncomeAnalytics},
		data() {
			return {
				activeTab:1,
			}
		},
		methods: {
		}
		,
		created() {

		}
		,
		computed: {

		}
		,
		watch: {

		}
		,
	}
</script>
<style>
	.nav-tabs .nav-link.active{
		color:white;
		background: #20a8d8 !important;
	}
</style>
